export function MailAttention({reasons}:{reasons:readonly string[]}){
  if(!reasons.length)return null;
  return <div className="mail-attention-signals"><strong>Review signals</strong><ul aria-label="Attention reasons">{reasons.map(reason=><li key={reason}>{reason}</li>)}</ul>{reasons.some(reason=>reason.startsWith('Urgent wording'))&&<p>Urgent wording is a signal to review. The recorded priority has not changed.</p>}</div>;
}
